var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('el-dialog',{attrs:{"top":"5vh","custom-class":"preview_dialog","title":_vm.title,"visible":_vm.dialogVisible},on:{"close":function($event){return _vm.$emit('close')}}},[_c('img',{attrs:{"width":"100%","src":_vm.dataURI,"alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }